import axios, { AxiosResponse } from 'axios';
import { BaseResponse } from 'models/baseResponse';
import store from 'cache/store';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_TXCB_MINIGAME,
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosInstance.interceptors.request.use(
    (config) => {
        const { apiToken } = store.getState().auth;

        if (apiToken) {
            config.headers['Authorization'] = `Bearer ${apiToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const txcbApi = {
    getRank(): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosInstance.get('/api/tx-ranks?type=1');
    },
    getHistoryMyBet(params: { page: number; size: number; sort: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosInstance.post('/api/tx/lichsucuoc', {}, { params });
    },
};
export default txcbApi;
